(function () {
  'use strict';

  var GA4_MEASUREMENT_ID = 'G-PKHVJ3LX7Z';
  var TRACKING_VERSION = 'trustpilot_engagement_20260722_v1';
  var WIDGET_SELECTOR = '.mma-trustpilot-widget[data-mma-trustpilot-placement]';
  var trackedImpressions = new Set();
  var lastTrackedFrame = null;
  var pendingBlurSequence = 0;
  var recordedBlurSequence = 0;

  function getCookie(name) {
    var prefix = name + '=';
    var item = document.cookie.split('; ').find(function (cookie) {
      return cookie.indexOf(prefix) === 0;
    });
    return item ? decodeURIComponent(item.slice(prefix.length)) : '';
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  function gaClientId() {
    var gaCookie = getCookie('_ga');
    var parts = gaCookie.split('.');
    if (parts.length >= 4) return parts.slice(-2).join('.');

    var storageKey = 'mma_trustpilot_ga_cid';
    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) return stored;
      var generated = Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
      window.sessionStorage.setItem(storageKey, generated);
      return generated;
    } catch (error) {
      return Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
    }
  }

  function gaSessionId() {
    var cookieName = '_ga_' + GA4_MEASUREMENT_ID.replace('G-', '');
    var match = getCookie(cookieName).match(/\$s(\d+)/);
    return match ? match[1] : String(Math.floor(Date.now() / 1000));
  }

  function pageType() {
    var className = document.documentElement.className || '';
    var match = className.match(/(?:^|\s)template-([^\s]+)/);
    if (match) return match[1];
    if (window.location.pathname === '/') return 'index';
    return window.location.pathname.split('/').filter(Boolean)[0] || 'unknown';
  }

  function productHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function eventPayload(widget, interactionMethod) {
    return {
      trustpilot_placement: widget.dataset.mmaTrustpilotPlacement || 'unknown',
      widget_template_id: widget.dataset.templateId || '',
      page_type: pageType(),
      page_path: window.location.pathname,
      product_handle: productHandle(),
      interaction_method: interactionMethod || '',
      tracking_version: TRACKING_VERSION
    };
  }

  function sendGa4Event(name, payload) {
    if (!analyticsAllowed()) return;

    var query = new URLSearchParams({
      v: '2',
      tid: GA4_MEASUREMENT_ID,
      cid: gaClientId(),
      en: name,
      _p: String(Date.now()),
      dl: window.location.href,
      dt: document.title,
      sr: window.screen.width + 'x' + window.screen.height,
      ul: (navigator.language || 'en-us').toLowerCase(),
      sid: gaSessionId(),
      sct: '1',
      seg: '1'
    });

    Object.entries(payload).forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];
      if (value === undefined || value === null || value === '') return;
      var prefix = typeof value === 'number' ? 'epn' : 'ep';
      query.set(prefix + '.' + key, String(value));
    });

    var endpoint = 'https://region1.analytics.google.com/g/collect?' + query.toString();
    var sent = false;
    try {
      sent = typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(endpoint, '');
    } catch (error) {
      sent = false;
    }

    if (!sent && typeof window.fetch === 'function') {
      window.fetch(endpoint, { method: 'POST', mode: 'no-cors', keepalive: true }).catch(function () {});
    }
  }

  function publish(widget, action, interactionMethod) {
    if (!widget) return;
    var placement = widget.dataset.mmaTrustpilotPlacement;
    if (!placement) return;

    var eventName = 'trustpilot_' + placement + '_' + action;
    var payload = eventPayload(widget, interactionMethod);
    sendGa4Event(eventName, payload);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (error) {
      // GA4 remains the canonical delivery path.
    }

    document.dispatchEvent(new CustomEvent('mma:trustpilot-engagement', {
      detail: Object.assign({ event: eventName }, payload)
    }));
  }

  function widgetForFrame(frame) {
    return frame && frame.closest ? frame.closest(WIDGET_SELECTOR) : null;
  }

  function activeTrustpilotFrame() {
    var active = document.activeElement;
    return active && active.tagName === 'IFRAME' && widgetForFrame(active) ? active : null;
  }

  function recordFocusedFrame(method) {
    window.setTimeout(function () {
      var frame = activeTrustpilotFrame();
      if (!frame || frame === lastTrackedFrame) return;
      lastTrackedFrame = frame;
      recordedBlurSequence = pendingBlurSequence;
      publish(widgetForFrame(frame), 'click', method);
    }, 0);
  }

  function observeImpressions() {
    if (!('IntersectionObserver' in window)) return;

    function recordImpressionIfReady(widget) {
      var placement = widget.dataset.mmaTrustpilotPlacement;
      if (
        widget.dataset.mmaTrustpilotVisible !== 'true' ||
        !placement ||
        trackedImpressions.has(placement) ||
        !widget.querySelector('iframe')
      ) return;
      trackedImpressions.add(placement);
      publish(widget, 'impression', 'intersection_50');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var widget = entry.target;
        widget.dataset.mmaTrustpilotVisible = String(entry.isIntersecting && entry.intersectionRatio >= 0.5);
        recordImpressionIfReady(widget);
      });
    }, { threshold: [0.5] });

    function addWidgets(root) {
      var widgets = [];
      if (root.nodeType === 1 && root.matches && root.matches(WIDGET_SELECTOR)) widgets.push(root);
      if (root.querySelectorAll) widgets = widgets.concat(Array.from(root.querySelectorAll(WIDGET_SELECTOR)));
      widgets.forEach(function (widget) {
        if (widget.dataset.mmaTrustpilotImpressionObserved === 'true') return;
        widget.dataset.mmaTrustpilotImpressionObserved = 'true';
        observer.observe(widget);
      });
    }

    addWidgets(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          addWidgets(node);
          var widget = widgetForFrame(node);
          if (widget) recordImpressionIfReady(widget);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest(WIDGET_SELECTOR + ' > a');
    if (link) publish(link.closest(WIDGET_SELECTOR), 'click', 'fallback_link');
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest || !event.target.closest(WIDGET_SELECTOR)) lastTrackedFrame = null;
  }, true);

  window.addEventListener('blur', function () {
    pendingBlurSequence += 1;
    recordFocusedFrame('iframe_focus_blur');
  });

  window.addEventListener('focus', function () {
    if (recordedBlurSequence !== pendingBlurSequence) recordFocusedFrame('iframe_focus_return');
    window.setTimeout(function () {
      var frame = activeTrustpilotFrame();
      if (frame && typeof frame.blur === 'function') frame.blur();
      lastTrackedFrame = null;
    }, 100);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') recordFocusedFrame('iframe_focus_hidden');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeImpressions, { once: true });
  } else {
    observeImpressions();
  }
})();
